import { Component } from 'preact';

import { FatalAttraction as FA } from '@vpr/tracking';

import { translate } from '@vimeo/i18n-runtime';

import styles from './TeamLogin.module.scss';

const VIMEO_BLUE = '#00adef';

class TeamLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: false,
    };
  }

  toggleDisabled = () => {
    this.setState((prevState) => ({
      disabled: !prevState.disabled,
    }));
  };

  render = (props, state) => {
    const { title, customLogo, color, sso, handleLogin } = props;
    const { disabled } = state;

    return (
      <div className={styles.errorState}>
        {customLogo && <img className={styles.errorStateLogo} src={customLogo.img} alt={title} />}
        <h1 className={styles.errorStateMessage}>
          {translate({
            singular: 'Sign in to {TITLE}',
            replacements: {
              TITLE: (children) => <span className={styles.errorStateBigMessage}>{title}</span>,
            },
          })}
        </h1>
        <button
          style={{
            backgroundColor: color ? `#${color}` : VIMEO_BLUE,
            borderColor: color ? `#${color}` : VIMEO_BLUE,
          }}
          className={styles.errorButton}
          disabled={disabled}
          onClick={() => {
            FA.trackClick({
              container: 'embedded_playlist',
              component: 'login',
              keyword: sso ? 'sso' : 'use_email_password',
            });
            handleLogin(sso);
          }}
        >
          {sso ? translate('Sign in with SSO') : translate('Sign in')}
        </button>
        {sso && (
          <div>
            <p className={styles.errorStateAdditionalMessage}>
              {translate({
                singular: '{A}Sign in{/A} with email and password',
                replacements: {
                  A: (children) => {
                    return (
                      <a
                        style={{
                          color: color ? `#${color}` : VIMEO_BLUE,
                        }}
                        className="sso-link"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          FA.trackClick({
                            container: 'embedded_playlist',
                            component: 'login',
                            keyword: 'email_password',
                          });
                          handleLogin(false);
                        }}
                      >
                        {children}
                      </a>
                    );
                  },
                },
              })}
            </p>
            <div className={styles.errorStateDivider}></div>
            <div className="opt-in-wrapper">
              <input
                type="checkbox"
                name="optIn"
                id="optIn"
                checked={!disabled}
                onClick={this.toggleDisabled}
              />
              <label className={styles.errorStateAdditionalMessage} htmlFor="optIn">
                {translate(
                  'I understand that the account creator and admins may access my viewing history, which can be changed in my account settings.',
                )}
              </label>
            </div>
          </div>
        )}
      </div>
    );
  };
}

export default TeamLogin;
